import { render, staticRenderFns } from "./FDarkModeSwitch.vue?vue&type=template&id=613ed1c1&"
import script from "./FDarkModeSwitch.vue?vue&type=script&lang=js&"
export * from "./FDarkModeSwitch.vue?vue&type=script&lang=js&"
import style0 from "./FDarkModeSwitch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports